<template>
  <a-modal :title="title" :width="800" :visible="visible" @ok="handleOk" @cancel="handleCancel">
    <list-page-view :needSearch="false">
      <uto-table-new :columns="columns" :dataSource="dataSource" bordered :pagination="false"> 
        <div slot="dpbvdateR" slot-scope="flag">{{ date2string(flag) }}</div>
      </uto-table-new>
    </list-page-view>
  </a-modal>
</template>
<script>
import { queryPurDQRBillDetailListByAutoId } from '@/api/scmApi'
import moment from 'moment'
export default {
  name: 'BillDetailInfo',
  data() {
    return {
      title: '发票明细',
      visible: false,
      dataSource: [],
      columns: [
        {
          title: '开票日期',
          dataIndex: 'dpbvdate',
          width: 150,
          scopedSlots: { customRender: 'dpbvdateR' }
        },
        {
          title: '发票号',
          dataIndex: 'cpbvcode',
          width: 150
        },
        {
          title: '发票类别',
          dataIndex: 'cpbvbilltype',
          width: 150,
        },
        {
          title: '业务类型',
          dataIndex: 'cbustype',
          width: 150
        },
        {
          title: '结算模式',
          dataIndex: 'ccashtype',
          width: 150
        },
        {
          title: '来源单据号',
          dataIndex: 'cordercode',
          width: 150
        },
        {
          title: '立帐日',
          dataIndex: 'dcreditstart',
          width: 150,
        },
        {
          title: '到期日',
          dataIndex: 'dgatheringdate',
          width: 150,
        },
        {
          title: '业务员',
          dataIndex: 'cpersonname',
          width: 150
        },
        {
          title: '部门名称',
          dataIndex: 'cdepname',
          width: 150
        },
        {
          title: '供应商编码',
          dataIndex: 'cvencode',
          width: 150
        },
        {
          title: '供应商名称',
          dataIndex: 'cvenname',
          width: 150
        },
        {
          title: '供应商存货编码',
          dataIndex: 'cveninvcode',
          width: 150
        },
        {
          title: '供应商存货名称',
          dataIndex: 'cveninvname',
          width: 150
        },
        {
          title: '存货编码',
          dataIndex: 'cinvcode',
          width: 150
        },
        {
          title: '存货名称',
          dataIndex: 'cinvname',
          width: 150
        },
        {
          title: '规格型号',
          dataIndex: 'cinvstd',
          width: 260
        },
        {
          title: '开票数量',
          dataIndex: 'ipbvquantity',
          width: 150
        },
        {
          title: '主计量单位',
          dataIndex: 'cinvm_unit',
          width: 150
        },
        {
          title: '开票单价',
          dataIndex: 'ikpcost',
          width: 150
        },
        {
          title: '开票金额',
          dataIndex: 'ikpmoney',
          width: 150
        },
        {
          title: '已付款金额',
          dataIndex: 'ifkmoney',
          width: 150
        },
        {
          title: '原币单价',
          dataIndex: 'ioricost',
          width: 150
        },
        {
          title: '原币含税单价',
          dataIndex: 'ioritaxcost',
          width: 150
        },
        {
          title: '原币金额',
          dataIndex: 'iorimoney',
          width: 150
        },
        {
          title: '原币价税合计',
          dataIndex: 'iorisum',
          width: 150
        },
        {
          title: '税率',
          dataIndex: 'itaxrate',
          width: 150
        },
        {
          title: '原币税额',
          dataIndex: 'ioritaxprice',
          width: 150
        },
        {
          title: '累计原币付款',
          dataIndex: 'ioritotal',
          width: 150
        },
        {
          title: '制单人',
          dataIndex: 'cpbvmaker',
          width: 150
        },
      ],
      pbvbillTypelist: this.$store.getters.moduleEnums.scm.pbvbillType.data
    }
  },
  created() {
  },
  methods: {
    date2string(df) {
      if (df) {
        return moment(df).format('YYYY-MM-DD')
      } else {
        return undefined
      }
    },
    toAdd(autoid) {
      const _that = this
      _that.visible = true
      queryPurDQRBillDetailListByAutoId({ autoid: autoid }).then(res => {
        if (res.code === 0 || res.code === '0') {
          _that.dataSource = res.data
        }
      })
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>